import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/布莱克";
import { Soulmark } from "../../core/soulmark";

export class 布莱克 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(875, "布莱克", type.暗影, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "自身首次阵亡时必定残留1点体力，同时回合结束时消除对手的能力提升和回合类效果，然后100%令对手害怕。",
            "若对手使用属性技能，则己方免疫下1次异常状态。",
            "若对手使用攻击技能，则自身有70%的几率闪避对手攻击。若闪避成功则下1回合造成的伤害提升100%。",
        ]);
        this.技能组 = [
            skill.夜·魔灵之球,
            skill.夜·幽幻之盾,
            skill.夜·斗志复燃,
            skill.夜·双重暗影,
            skill.夜神·魔君舞,
        ];
    }
}